

















import Vue from "vue";
import ResetPasswordForm from "@/components/organisms/ResetPasswordForm/index.vue";

export default Vue.extend({
  name: "reset-password",
  components: { ResetPasswordForm },
  data() {
    return {
      newPassword: {},
    };
  },
  props: {
    title: {
      type: String,
      default: "パスワードリセット",
    },
  },
  methods: {
    handleOnResetPassword(newPassword: any) {
      this.$emit("resetPassword", newPassword);
    },
  },
});
